import React from "react";
import { Text as RNText, TextProps as RNTextProps } from "react-native";
import { colors, typography } from "@/constants";

interface TextProps extends RNTextProps {
  /** Font weight variant - defaults to regular */
  variant?: "regular" | "medium" | "semiBold" | "bold";
  /** Font size from typography constants */
  size?: keyof typeof typography.fontSizes;
  /** Text color - defaults to textPrimary */
  color?: "primary" | "secondary" | "tertiary";
}

/**
 * A styled Text component that automatically applies Inter font family
 * and provides easy access to font variants and sizes from typography constants.
 *
 * This component should be used instead of React Native's Text component
 * to ensure consistent font usage throughout the app.
 */
export default function Text({
  variant = "regular",
  size = "medium",
  color = "primary",
  style,
  ...props
}: TextProps) {
  const fontFamily = typography.fontFamily[variant];
  const fontSize = typography.fontSizes[size];
  const textColor =
    color === "primary"
      ? colors.onSurface
      : color === "secondary"
        ? colors.onSurfaceVariant
        : colors.onSurfaceMuted;

  return (
    <RNText
      style={[
        {
          fontFamily,
          fontSize,
          color: textColor
        },
        style
      ]}
      {...props}
    />
  );
}
